import React from "react";
import { createRoot } from "react-dom/client";
import { Buffer } from "buffer";
import App from "./App";
import "./index.css";

import { CameraProvider } from "./context/CameraContext";
import { NFTProvider } from "./context/NFTContext";
import { TransactionsProvider } from "./context/TransactionContext";

if (!window.Buffer) {
  window.Buffer = Buffer;
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <CameraProvider>
    <NFTProvider>
      <TransactionsProvider>
        <App />
      </TransactionsProvider>
    </NFTProvider>
  </CameraProvider>
);
